import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule } from '@ngx-translate/core';
import {
  ApiModule as UaaApiModule,
  Configuration as UaaConfiguration,
} from '@renovationman/rm-uaa-api-client-ts-ng20';
import { ToastrModule } from 'ngx-toastr';

import { environment } from '~env';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApiErrorInterceptor } from './interceptors/api-error.interceptor';
import { AuthCallbackPage } from './pages/auth-callback/auth-callback.page';
import { CookiesRequiredPage } from './pages/cookies-required/cookies-required.page';
import { ForgottenPasswordPage } from './pages/forgotten-password/forgotten-password.page';
import { LoginPage } from './pages/login/login.page';
import { LogoutPage } from './pages/logout/logout.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';

@NgModule({
  declarations: [
    AppComponent,
    LogoutPage,
    ForgottenPasswordPage,
    ResetPasswordPage,
    LoginPage,
    AuthCallbackPage,
    CookiesRequiredPage,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot(),
    UaaApiModule.forRoot(
      () => new UaaConfiguration({ basePath: environment.apiBasePaths.uaa })
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiErrorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
